// Pressing on selected text and moving drags the text away, as the browser does it; here it selects anew from there, as
// pressing anywhere else does. Only a press inside the selection: one on a button leaves it, e.g. to act on it. Not a
// shift-press, which extends it, a double or triple press, which selects a word or a line, or a press in a field.
const isInSelection = (selection: Selection, x: number, y: number) =>
    [...selection.getRangeAt(0).getClientRects()].some(
        (rect) => x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom
    );

export const startSelectionOnPress = (event: MouseEvent) => {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed || selection.rangeCount === 0) return;
    if (event.button !== 0 || event.shiftKey || event.detail > 1) return;
    if (event.target instanceof Element && event.target.closest('input, textarea, [contenteditable]')) return;
    if (isInSelection(selection, event.clientX, event.clientY)) selection.removeAllRanges();
};
